import React, {useEffect, useState} from 'react';
import {Avatar, Badge, styled, Tooltip} from '@mui/material';
import {getAvatarColorSx} from './avatarColor';

const getBadgeColor = (user) => {
    switch (user.status) {
        case 'ACTIVE':
            return '#44b700';
        case 'AWAY':
            return '#FFA500';
        case 'OFFLINE':
        default:
            return '#999';
    }
};

const StyledBadge = styled(Badge, {
    shouldForwardProp: (prop) => prop !== 'badgecolor',
})(({theme, badgecolor}) => ({
    '& .MuiBadge-badge': {
        backgroundColor: badgecolor,
        color: badgecolor,
        width: 10,
        height: 10,
        borderRadius: '50%',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    },
}));

const DisabledBadge = styled(Badge)(({theme}) => ({
    '& .MuiBadge-badge': {
        width: 10,
        height: 10,
        borderRadius: '50%',
        border: '2px solid #999',
        backgroundColor: '#fff', // white center for disabled users
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    },
}));

const UserAvatar = ({user, tooltip, onClick, hideStatus = false}) => {
    const [validGravatar, setValidGravatar] = useState(true);

    useEffect(() => {
        if (user.gravatarUrl) {
            fetch(user.gravatarUrl, {method: 'HEAD'})
                .then((response) => {
                    if (!response.ok) setValidGravatar(false);
                })
                .catch(() => setValidGravatar(false));
        } else {
            setValidGravatar(false);
        }
    }, [user.gravatarUrl]);

    const avatarProps =
        validGravatar && user.gravatarUrl
            ? {src: user.gravatarUrl}
            : {sx: getAvatarColorSx(user.color)};

    const avatar = (
        <Tooltip title={tooltip}>
            <Avatar {...avatarProps} onClick={onClick}>
                {!validGravatar && user.initials}
            </Avatar>
        </Tooltip>
    );

    if (hideStatus) return avatar;

    if (!user.enabled) {
        return (
            <DisabledBadge
                overlap="circular"
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                variant="dot"
            >
                {avatar}
            </DisabledBadge>
        );
    }

    const badgeColor = getBadgeColor(user);

    return (
        <StyledBadge
            badgecolor={badgeColor}
            overlap="circular"
            anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
            variant="dot"
        >
            {avatar}
        </StyledBadge>
    );
};

export default UserAvatar;
